'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeIERequest = makeIERequest;
exports.makeStandardRequest = makeStandardRequest;
exports.default = makeRequest;
function makeIERequest(url, callback) {
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
    var bodyParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var xdr = new XDomainRequest();

    console.log('making request with XDR');

    xdr.open(method.toLowerCase(), url);

    xdr.ontimeout = function () {
        return console.error('hit timeout in XDR');
    };

    xdr.onerror = function () {
        return console.error('hit error in XDR');
    };

    xdr.onload = function () {
        return callback(JSON.parse(xdr.responseText));
    };

    xdr.onprogress = function () {
        return console.log('if you dont include this, the request will abort in IE9');
    };

    setTimeout(function () {
        return xdr.send(bodyParams);
    }, 100);
}

function makeStandardRequest(url, callback) {
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
    var bodyParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    var xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4) {
            callback(JSON.parse(xmlhttp.responseText));
        }
    };

    xmlhttp.open(method, url, true);
    if (headers) {
        Object.keys(headers).forEach(function (k) {
            return xmlhttp.setRequestHeader(k, headers[k]);
        });
    }

    xmlhttp.send(bodyParams);
}

function makeRequest() {
    var fn = window.XDomainRequest ? makeIERequest : makeStandardRequest;
    fn.apply(undefined, arguments);
}


//////////////////
// WEBPACK FOOTER
// ./~/icarus-forms/module/js/lib/ajax.js
// module id = 195
// module chunks = 2 3